// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__890TX","obliqueLineWrap":"membershipbadge_obliqueLineWrap__38tQr","obliqueLine":"membershipbadge_obliqueLine__2h5zz"};